import { render, staticRenderFns } from "./collapseCoponent.vue?vue&type=template&id=37a1c888&scoped=true&"
import script from "./collapseCoponent.vue?vue&type=script&lang=js&"
export * from "./collapseCoponent.vue?vue&type=script&lang=js&"
import style0 from "./collapseCoponent.vue?vue&type=style&index=0&id=37a1c888&prod&lang=css&"
import style1 from "./collapseCoponent.vue?vue&type=style&index=1&id=37a1c888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1c888",
  null
  
)

export default component.exports